import React from 'react';

export function parseHtmlAttribution(htmlString) {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;

  const anchorTags = tempDiv.querySelectorAll('a');
  const elements = [];

  anchorTags.forEach((anchor, index) => {
    elements.push(
      <a
        key={index}
        href={anchor.href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {anchor.textContent || anchor.innerHTML}
      </a>
    );
  });

  return elements;
}
